module.exports = __webpack_public_path__ + "img/IMG_8947.8080b538.jpg";